<template>
  <div>
    <h1>NotFoundScreen</h1>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/NotFound/components/NotFoundScreen.vue